<div [class]="'border rounded-md p-3 mb-4 relative ' + bgColor + ' ' + borderColor" role="alert">
  <p [class]="'font-semibold ' + titleColor">{{ title }}</p>
  <p [class]="'text-sm ' + messageColor">{{ message }}</p>
  @if (closeable) {
    <button
      type="button"
      [class]="'absolute top-2 right-2 font-bold hover:opacity-80 transition-opacity ' + titleColor"
      aria-label="Close alert"
      (click)="close()"
    >
      ×
    </button>
  }
</div>
